"use strict";

;
(function (AboutCirclePopup, $) {
  var closePopupCircle = function closePopupCircle() {
    $('.mobile-popup-circle').fadeOut(300);
  };
  var goToSection = function goToSection(number) {
    var section = ".block-content[data-number=\"".concat(number, "\"]");
    if (window.innerWidth <= 1023) {
      // MOBILE TO TABLET
      $('html, body').animate({
        scrollTop: $(section).offset().top - 100
      }, 0);
    } else {
      // DESKTOP
      $('html, body').animate({
        scrollTop: $(section).offset().top + 30
      }, 0);
    }
  };
  var eventHandlers = function eventHandlers() {
    // OPEN CENTER POP-UP
    $('.principle').on('click', function () {
      if (window.innerWidth <= 1023) {
        var color = $(this).data('color');
        var number = $(this).data('number');
        var hoverText = $(this).data('hover-text');
        $('.mobile-popup-circle').css({
          "background-color": color
        });
        $('.mobile-popup-circle .number').text(number);
        $('.mobile-popup-circle .text').text(hoverText);
        $('.mobile-popup-circle').fadeIn(300);
      }
    });

    // CLOSE CENTER POP-UP
    $('.mobile-popup-circle .close').on('click', function () {
      closePopupCircle();
    });

    // GO TO SECTION - MOBILE
    $('.mobile-popup-circle a').on('click', function (e) {
      e.preventDefault();
      var number = $(this).closest('.mobile-popup-circle').find('.number').text();
      goToSection(number);
      closePopupCircle();
    });

    // GO TO SECTION - DESKTOP
    $('.hover-circle a').on('click', function (e) {
      e.preventDefault();
      var number = $(this).data('number');
      goToSection(number);
    });
  };
  AboutCirclePopup.init = function () {
    eventHandlers();
  };
})(window.AboutCirclePopup = window.AboutCirclePopup || {}, jQuery, undefined);